module.exports = __webpack_public_path__ + "static/media/customer-search.6d41af20.svg";